import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";

import { PageHero, PolicyBody } from "../../components/site/Page";
import { TermsPolicyContent } from "../../components/site/EnrollmentPolicyContent";

const title = "Terms of use | Swedish International School";
const description =
  "Terms for using sweintschool.com and the school's application form: what applies to data, fees and confirmation of a place.";

export const Route = createFileRoute("/en/terms")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl("/en/terms") },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "en_GB" },
      ...ogImage(),
    ],
    links: seoLinks("/en/terms"),
  }),
  component: Terms,
});

function Terms() {
  return (
    <>
      <PageHero
        eyebrow="Terms"
        title="Terms of use"
        intro="These terms apply when you use the school's website and when you submit an application via the form."
      />

      <PolicyBody>
        <TermsPolicyContent locale="en" />
      </PolicyBody>
    </>
  );
}
